import styled from 'styled-components'

export const Grid4 = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(0, 1fr);
  grid-auto-rows: 384px;
  align-items: stretch;
  gap: 14px;

  @media (max-width: 1000px) {
    grid-template-columns: minmax(0, 1fr);
    grid-auto-rows: auto;
  }
`

/* preenche a altura do painel com scroll (Total flui no fim, cabecalho fixo) */
export const PanelScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c7ccd4;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  @media (max-width: 1000px) {
    flex: none;
    max-height: 360px;
  }
`

/* ---- barras verticais agrupadas (Recebimentos x Pagamentos) ---- */
export const GBars = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 24px;
  flex: 1;
  min-height: 220px;
  padding: 28px 8px 0;
  overflow-x: auto;

  @media (max-width: 1000px) {
    flex: none;
    height: 260px;
  }
`

export const GGroup = styled.div`
  flex: 1 1 160px;
  min-width: 160px;
  max-width: 320px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  .pair {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 38px;
    width: 100%;
    height: 100%;
  }
  .bar-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    flex: 1;
    max-width: 46px;
  }
  .cap {
    font-size: 11px;
    font-weight: 700;
    color: #4a4f57;
    margin-bottom: 6px;
    white-space: nowrap;
  }
  .bar {
    width: 100%;
    min-height: 3px;
  }
  .bar.blue {
    background: #29abe2;
  }
  .bar.yellow {
    background: #f5b301;
  }
  .xlabel {
    margin-top: 8px;
    font-size: 15px;
    color: #6b7280;
  }
`

export const Legend = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 24px;
  margin-top: 8px;
  padding-left: 6px;
  font-size: 14px;
  color: #4a4f57;

  span {
    display: inline-flex;
    align-items: center;
  }
  .dot {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    margin-right: 7px;
  }
  .dot.blue {
    background: #29abe2;
  }
  .dot.yellow {
    background: #f5b301;
  }
`
